import TurnoLaboralService from 'src/modules/turnoLaboral/turnoLaboralService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TURNOLABORAL_VIEW';

const turnoLaboralViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: turnoLaboralViewActions.FIND_STARTED,
      });

      const record = await TurnoLaboralService.find(id);

      dispatch({
        type: turnoLaboralViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: turnoLaboralViewActions.FIND_ERROR,
      });

      getHistory().push('/turno-laboral');
    }
  },
};

export default turnoLaboralViewActions;
